import { ref } from '@vue/composition-api';
import { userService } from '@/bundles/Users/factory/UserServiceFactory';
import { IQueryObjectParam } from '@/bundles/App/type';

export function useUsers() {
  const users = ref<any[]>([]);
  const total = ref(0);
  const pending = ref(false);
  const downloadLoading = ref(false);

  async function fetch(params: IQueryObjectParam[]) {
    pending.value = true;
    const { data, total: usersTotal } = await userService.list(params);
    users.value = data;
    total.value = usersTotal;
    pending.value = false;
  }

  async function exportToCsv(params: IQueryObjectParam[]) {
    downloadLoading.value = true;
    const link = await userService.exportToCsv(params);
    window.location.replace(link);
    downloadLoading.value = false;
  }

  return {
    users,
    total,
    pending,
    downloadLoading,
    fetch,
    exportToCsv,
  };
}
